import React from 'react';
import { Layout } from 'antd';
import PropTypes from 'prop-types';
import { PageSpace, TabButton, TabContent } from '../styled';
import style from './index.scss';
import ResultTab from '../ResultTab';
import SummaryTab from '../SummaryTab';

const { Content } = Layout;

// FIN-13574 — the Summary / Results choice lives in the URL.
//
// It was `useState(false)`, so it reset to Summary on every arrival: a refresh,
// a bookmark, the browser back button, or the alert detail page's "← Alerts"
// link. The alerts an analyst is working through are under RESULTS, so coming
// back from an alert always landed on an unrelated tab.
//
// `?view=results` matches the pattern the OUTER tabs already use on this page
// (index.js reads `?tab=`), so the two halves of the same screen now address
// themselves the same way.
//
// REPLACE, NOT PUSH: switching tabs is not a navigation an analyst wants to
// undo one step at a time. Pushing would stack an entry per click and make the
// browser's back button walk the tab history instead of leaving the page.
const RESULTS_VIEW = 'results';

// `history` and `location` come from the PARENT, which already has them from
// withRouter (testRunInstanceDashboard/index.js). Taking them as plain props
// rather than wrapping this component too keeps it a pure function of its
// inputs — react-router v4's withRouter uses the legacy context API, which does
// not inject under the test harness, so a wrapped component cannot be tested at
// this level at all.
const Prevention = ({ history, location }) => {
  const isResult =
    new URLSearchParams(location.search).get('view') === RESULTS_VIEW;

  const setView = (wantResults) => {
    // Preserves every other param — `?tab=` in particular, which selects the
    // Prevention/Detection tab this component sits inside. Rebuilding the query
    // from scratch would drop it and bounce the user to the first outer tab.
    const params = new URLSearchParams(location.search);
    if (wantResults) params.set('view', RESULTS_VIEW);
    else params.delete('view');

    const query = params.toString();
    history.replace(`${location.pathname}${query ? `?${query}` : ''}`);
  };

  return (
    <Content>
      <PageSpace size={0} direction="vertical">
        <TabContent>
          <TabButton
            className={!isResult ? style.active : ''}
            onClick={() => setView(false)}>
            Summary
          </TabButton>
          <TabButton
            className={isResult ? style.active : ''}
            onClick={() => setView(true)}>
            Results
          </TabButton>
        </TabContent>
        {isResult ? <ResultTab /> : <SummaryTab from="Prevention" />}
      </PageSpace>
    </Content>
  );
};

Prevention.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default Prevention;
